import styled from 'styled-components';
import { colors, font } from 'stylesheet';

export const Title = styled.h2`
  color: ${colors.purple};
  ${font.size20};
`;

export default Title;
